<template>
  <div>
    <h2 v-if="error" class="Error" :style="{ paddingTop: this.hauteur }">
      Accès refusé
    </h2>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Favoris",
  data: () => ({
    hauteur: "100px",
    error: false,
  }),
  computed: {
    ...mapState({
      clients: (state) => state.client.list,
      user: (state) => state.auth.user,
    }),
  },
  watch: {
    clients() {
      if (this.clients.length > 0) {
        //if (this.$route.query.callbackurl.indexOf("voyages-lambert") !== -1) {
        if (this.$route.query.callbackurl.indexOf("?") === -1) {
          window.location.href =
            this.$route.query.callbackurl +
            "?token=" +
            this.user.token +
            "&refresh=" +
            this.user.refresh_token;
          return;
        } else {
          window.location.href =
            this.$route.query.callbackurl +
            "&token=" +
            this.user.token +
            "&refresh=" +
            this.user.refresh_token;
          return;
        }
        //  }
      }
      this.error = true;
    },
  },
  mounted() {
    this.resizeHauteur();
  },
  methods: {
    onResize() {
      this.resizeHauteur();
    },
    resizeHauteur() {
      this.hauteur = window.innerHeight / 3 + "px";
    },
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped>
.Error {
  color: rgb(139, 31, 31);
  font-size: 200px;
  text-align: center;
}
</style>
